import React, { Component } from 'react';
import { addDays, format } from 'date-fns';
import brandToString from '../../utils/brandToString';
import en from '../../international/translations/en';

class UpgradeHeader extends Component {
  getTitleText = () => {
    const {
      trialEligible = true,
    } = this.props;
    if (!trialEligible) return 'It looks like you have already taken a free trial or promotional offer.';
    return `Start your ${brandToString()} Premium subscription today!`;
  }

  getSubtitleText = () => {
    const {
      trialEligible = true,
      coupon = false,
      trialPeriodDays,
    } = this.props;
    if (trialEligible && coupon) return `Discounted subscriptions are not eligible for free trials. Billing will begin today, ${this.formatToday()}.`;
    let text = `Billing begins after free trial ends on ${this.formatTrialEndDate()}.`;
    if (!trialEligible || !trialPeriodDays) text = `Billing will begin today, ${this.formatToday()}.`;
    return (
      <p className="upgrade-header__subtitle">{text}</p>
    );
  }

  formatToday = () => format(new Date(), 'MM/DD/YY');

  formatTrialEndDate = () => {
    const trialEnd = addDays(new Date(), 15);
    return format(trialEnd, 'MM/DD/YY');
  };

  render() {
    const { children, hideSubtitle } = this.props;
    const { upgradeFunnel: { upgradeHeaderSubstitle } } = en;
    return (
      <div className="upgrade-header">
        <h1 className="upgrade-header__title">
          {this.getTitleText()}
        </h1>
        {hideSubtitle ? (
          <div>
            <p className="upgrade-header__subtitle">
              {upgradeHeaderSubstitle}
            </p>
            {children}
          </div>
        )
          : this.getSubtitleText()}
      </div>
    );
  }
}

export default UpgradeHeader;
